import Vue from "vue";
import { mapMutations, mapState } from "vuex";
export default Vue.extend({
    computed: mapState(["messages"]),
    methods: mapMutations(["removeNotificationMessage"]),
});
